// extracted by mini-css-extract-plugin
export default {"containerWrapper":"no-supplier-placeholder_containerWrapper__U-9kY"};